var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items
    ? _c("div", { staticClass: "list" }, [
        _vm.title
          ? _c("p", {
              staticClass: "list__title",
              domProps: { innerHTML: _vm._s(_vm.title) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "list__items",
            class: { "list__items--errors": _vm.displayErrors }
          },
          _vm._l(_vm.items, function(message) {
            return _c("li", {
              domProps: { innerHTML: _vm._s(_vm.trans(message)) }
            })
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }